module.exports = __webpack_public_path__ + "static/media/FR.0846f86e.svg";